interface TaskSubmissionNotesProps {
    installerNote?: string | null;
    notes?: string | null;
}

export function TaskSubmissionNotes({ installerNote, notes }: TaskSubmissionNotesProps) {
    const trimmedInstallerNote = installerNote?.trim() || null;
    const trimmedNotes = notes?.trim() || null;

    if (!trimmedInstallerNote && !trimmedNotes) {
        return null;
    }

    return (
        <div className="space-y-0.5">
            {trimmedInstallerNote && (
                <div className="text-xs text-gray-500 italic">Installer note: {trimmedInstallerNote}</div>
            )}
            {trimmedNotes && (
                <div className="text-xs text-amber-700">Discrepancy note: {trimmedNotes}</div>
            )}
        </div>
    );
}
